import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
const TOKEN_KEY = 'blokswap_admin_token';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({
  headers: { Authorization: `Bearer ${getAdminToken()}` },
});

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/login`, { password });
  setAdminToken(data.token);
  return data.token;
};

export const listBots = async () => {
  const { data } = await axios.get(`${API}/bots`, authHeader());
  return data;
};

export const createBot = async (payload) => {
  const { data } = await axios.post(`${API}/bots`, payload, authHeader());
  return data;
};

export const updateBot = async (id, payload) => {
  const { data } = await axios.put(`${API}/bots/${id}`, payload, authHeader());
  return data;
};

export const deleteBot = async (id) => {
  const { data } = await axios.delete(`${API}/bots/${id}`, authHeader());
  return data;
};

export const botStats = async (id) => {
  const { data } = await axios.get(`${API}/bots/${id}/stats`, authHeader());
  return data;
};

export const botTrades = async (id, limit = 50) => {
  const { data } = await axios.get(`${API}/bots/${id}/trades?limit=${limit}`, authHeader());
  return data;
};
